import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        component: 'wtLogsState',
        name: 'logs',
        url: '/logs',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator, Roles.administrator, Roles.master, Roles.engineer]),
            license: Resolve.licenseResolve
        },
        abstract: false,
        redirectTo: 'logs.table',
        data: {
            visible: true,
            sortingOrder: 110,
            icon: 'fa-stethoscope',
            displayName: 'Logs',
            permission: {
                user: 'administrator'
            },
            editButtonVisibility: () => false,
        }
    }, {
        component: 'wtLogsTableState',
        name: 'logs.table',
        url: '/table',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator, Roles.administrator, Roles.master, Roles.engineer]),
            license: Resolve.licenseResolve
        },
        abstract: false,
        data: {
            visible: false,
            sortingOrder: 100,
            icon: 'fa-table',
            displayName: 'Logs',
            permission: {
                user: 'administrator'
            },
            editButtonVisibility: () => false,
        }
    }, {
        // component: 'wtLogsByApplicationState',
        template: '<wt-logs-by-application-state class="flex-directive col" logs="vm.logs" is-loading="vm.isLoading"></wt-logs-by-application-state>',
        name: 'logs.timeline',
        url: '/timeline',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator, Roles.administrator, Roles.master, Roles.engineer]),
            license: Resolve.licenseResolve
        },
        abstract: false,
        data: {
            visible: false,
            sortingOrder: 200,
            icon: 'fa-line-chart',
            displayName: 'Timeline',
            permission: {
                user: 'administrator'
            },
            editButtonVisibility: () => false,
        }
    }, {
        template: '<wt-logs-overview class="flex-directive col" logs="vm.logs" is-loading="vm.isLoading"></wt-logs-overview>',
        name: 'logs.overview',
        url: '/overview',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([Roles.superAdministrator, Roles.administrator, Roles.master, Roles.engineer]),
            license: Resolve.licenseResolve
        },
        abstract: false,
        data: {
            visible: false,
            sortingOrder: 300,
            icon: 'fa-eye',
            displayName: 'Overview',
            permission: {
                user: 'administrator'
            },
            editButtonVisibility: () => false,
        }
    }
];

export default states;